import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdDialogComponent } from './ad-dialog.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { AdDialogService } from './ad-dialog.service';
import { AConfirmComponent } from './a-confirm/a-confirm.component';
import { AdButtonModule } from '../ad-button/ad-button.module';

@NgModule({
  declarations: [AdDialogComponent, AConfirmComponent, AConfirmComponent],
  imports: [CommonModule, OverlayModule, PortalModule, AdButtonModule],
  exports: [AdDialogComponent, AConfirmComponent],
  providers: [AdDialogService],
  //entryComponents: [AdDialogComponent, AConfirmComponent]
})
export class AdDialogModule { }

export * from './ad-dialog.component';
export * from './ad-dialog.service';
export * from './ad-dialog-config';
export * from "./a-confirm/a-confirm.component";
export * from './common/ad-dialog-config-inject-key';
